import {createContext} from 'react';

import type {Shop} from './types';

export const ShopContext = createContext<Shop>({
  shopId: '',
  shopDomain: '',
  shopEmail: '',
  machineTranslationEnabled: false,
  machineTranslationLocaleLimit: 0,
  machineTranslationCustomCredentialsEnabled: false,
  currentThemeId: '',
  features: {
    autoSyncSupport: false,
    managedPrivacyPolicy: false,
    privacyCompliantByDefault: false,
  },
});
